function loadScript(src: string, id: string) {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = id;
    script.src = src;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Could not load social sign-in"));
    document.head.appendChild(script);
  });
}

export async function loadGoogleIdentity() {
  await loadScript("https://accounts.google.com/gsi/client", "google-identity-services");
  if (!window.google?.accounts?.id) {
    throw new Error("Google sign-in is unavailable");
  }
  return window.google.accounts.id;
}

export async function startAppleSignIn() {
  const clientId = import.meta.env.VITE_APPLE_CLIENT_ID as string | undefined;
  if (!clientId) {
    throw new Error("Apple sign-in is not configured");
  }

  await loadScript(
    "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
    "apple-sign-in"
  );

  if (!window.AppleID?.auth) {
    throw new Error("Apple sign-in is unavailable");
  }

  window.AppleID.auth.init({
    clientId,
    scope: "name email",
    redirectURI: (import.meta.env.VITE_APPLE_REDIRECT_URI as string | undefined) || `${window.location.origin}/login`,
    usePopup: true,
  });

  const response = await window.AppleID.auth.signIn();
  const idToken = response.authorization?.id_token;
  if (!idToken) {
    throw new Error("Apple did not return a sign-in token");
  }

  const firstName = response.user?.name?.firstName ?? "";
  const lastName = response.user?.name?.lastName ?? "";
  const name = [firstName, lastName].filter(Boolean).join(" ");

  return {
    idToken,
    name: name || undefined,
  };
}
